import Vue from "vue";

export default {
    addFutureDeliveryRequest(state, futureDeliveryRequest) {
        if (futureDeliveryRequest) {
            state.futureDeliveryRequests.push(futureDeliveryRequest);
        }
    },
    removeFutureDeliveryRequest(state, futureDeliveryRequestID) {
        const index = state.futureDeliveryRequests.findIndex(
            (r) => r.id === futureDeliveryRequestID,
        );
        if (index !== -1) {
            state.futureDeliveryRequests.splice(index, 1);
        }
    },
    updateFutureDeliveryRequest(state, futureDeliveryRequest) {
        if (!futureDeliveryRequest) return;
        const index = state.futureDeliveryRequests.findIndex(
            (schedule) => schedule.id === futureDeliveryRequest.id,
        );
        if (index !== -1) {
            Vue.set(state.futureDeliveryRequests, index, {
                ...state.futureDeliveryRequests[index],
                ...futureDeliveryRequest,
            });
        }
    },
};
